
import React from 'react';
import './Likert.css'
import { GLStep } from '../../../ViewModel/TutorialStateViewModel';
import { TutorialFlyout } from '../SharedComponents/TutorialFlyout';

export interface ILikertVM {
    title: string;
    onScoreChange: (value: number) => void;
    scoreFN: () => number | undefined;
    shouldShow?: () => boolean;
}

interface ILikertProps extends ILikertVM {
    className?: string;
    tutorialSteps?: GLStep[];
}


export function Likert({ className, title, onScoreChange, scoreFN, tutorialSteps, shouldShow }: ILikertProps) {

    const score = scoreFN();
    const [activeIndex, setActiveIndex] = React.useState(score);


    console.log('score', score);
    const renderCircle = (index: number, text?: string) => {
        return (
            <div
                className='gl-likert-option flex flex-column justify-content-start align-items-center'
                onClick={() => {
                    setActiveIndex(index);
                    onScoreChange(index);
                }}
            >
                <div className={`gl-likert-circle gl-likert-${activeIndex === index ? 'active' : ''}`}></div>
                {text && <>
                    <div className='gl-dailyscore-line'></div>
                    <p className='gl-likert-label gl-dailyscore-label-typography'>{text}</p>
                </>}
            </div>
        );
    }

    if (shouldShow && shouldShow() === false) return <></>;

    return (
        <div className={`gl-likert flex flex-column mb-4 mt-200 ${className ?? ''}`}>

            <TutorialFlyout steps={tutorialSteps}>
                <div className='flex flex-row justify-content-start align-items-center mb-3'>

                    <h3 className='gl-content-header-typography gl-likert-header'>{title}</h3>
                </div>
            </TutorialFlyout>
            <div className=''>
                <div className='relative flex flex-column align-items-center'>
                    {/* <div className='gl-daily-score-track'></div> */}
                    <div className='gl-daily-score-circles flex flex-row justify-content-between w-full'>
                        {renderCircle(1, 'Extremely dissatisfied')}
                        {renderCircle(2,)}
                        {renderCircle(3,)}
                        {renderCircle(4, 'Neither satisfied nor dissatisfied')}
                        {renderCircle(5,)}
                        {renderCircle(6,)}
                        {renderCircle(7, 'Extremely satisfied')}
                    </div>
                </div>
            </div>
        </div>
    );
}